if (!customElements.get("ajen-sticky-atc")) {
  customElements.define(
    "ajen-sticky-atc",
    class AjenStickyAtc extends HTMLElement {
      connectedCallback() {
        this.submitButton = this.querySelector("[data-ajen-sticky-submit]");
        this.variantEl = this.querySelector("[data-ajen-sticky-variant]");
        this.scentEl = this.querySelector("[data-ajen-sticky-scent]");
        this.priceEl = this.querySelector("[data-ajen-sticky-price]");
        this.labelEl = this.querySelector("[data-ajen-sticky-label]");
        this.observeSelector = this.dataset.observeSelector;
        this.sectionId = this.dataset.section;
        this.productTitle = (this.dataset.productTitle || "").trim();
        this.inFlowButton = this.observeSelector
          ? document.querySelector(this.observeSelector)
          : null;
        this.cookieBanner = document.getElementById("shopify-pc__banner");
        this.inFlowVisible = false;
        this.footerVisible = false;
        this.mediaQuery = window.matchMedia("(max-width: 749px)");

        this.onSubmit = this.onSubmit.bind(this);
        this.onVariantChange = this.onVariantChange.bind(this);
        this.onMedia = this.syncVisibility.bind(this);
        this.submitButton.addEventListener("click", this.onSubmit);

        if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
          this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange);
        }

        if (this.inFlowButton && "IntersectionObserver" in window) {
          this.buttonObserver = new IntersectionObserver(
            (entries) => {
              this.inFlowVisible = entries.some((entry) => entry.isIntersecting && entry.intersectionRatio > 0.4);
              this.syncVisibility();
            },
            { threshold: [0, 0.4, 1], rootMargin: "0px" }
          );
          this.buttonObserver.observe(this.inFlowButton);
        }

        const footer = document.querySelector("#shopify-section-footer, footer.footer, .footer");
        if (footer && "IntersectionObserver" in window) {
          this.footerObserver = new IntersectionObserver(
            (entries) => {
              this.footerVisible = entries.some((entry) => entry.isIntersecting && entry.intersectionRatio > 0.05);
              this.syncVisibility();
            },
            { threshold: [0, 0.05, 0.2] }
          );
          this.footerObserver.observe(footer);
        }

        this.bindCookieBanner();
        this.cookieTries = 0;
        this.cookieTimer = window.setInterval(() => {
          this.bindCookieBanner();
          this.offsetCookie();
          this.syncVisibility();
          this.cookieTries += 1;
          if (this.cookieTries > 20) window.clearInterval(this.cookieTimer);
        }, 250);

        if (this.mediaQuery.addEventListener) {
          this.mediaQuery.addEventListener("change", this.onMedia);
        } else {
          this.mediaQuery.addListener(this.onMedia);
        }

        this.syncFromDom();
        this.syncVisibility();
      }

      disconnectedCallback() {
        this.submitButton.removeEventListener("click", this.onSubmit);
        if (this.unsubscribeVariant) this.unsubscribeVariant();
        if (this.buttonObserver) this.buttonObserver.disconnect();
        if (this.footerObserver) this.footerObserver.disconnect();
        if (this.cookieObserver) this.cookieObserver.disconnect();
        if (this.cookieTimer) window.clearInterval(this.cookieTimer);
        if (this.mediaQuery.removeEventListener) {
          this.mediaQuery.removeEventListener("change", this.onMedia);
        } else if (this.mediaQuery.removeListener) {
          this.mediaQuery.removeListener(this.onMedia);
        }
      }

      onSubmit(event) {
        event.preventDefault();
        if (!this.inFlowButton || this.inFlowButton.hasAttribute("disabled")) return;
        this.inFlowButton.click();
      }

      onVariantChange(event) {
        if (!event || !event.data) return;
        const sectionId = event.data.sectionId;
        if (sectionId && this.sectionId && String(sectionId) !== String(this.sectionId)) return;
        this.syncFromDom(event.data.html);
      }

      syncFromDom(html) {
        const root = html || document;
        const priceSource = document.getElementById(`price-${this.sectionId}`);
        if (this.priceEl && priceSource) {
          this.priceEl.innerHTML = priceSource.innerHTML;
        }

        const selected = document.querySelector(
          `variant-radios[data-section="${this.sectionId}"] input[type="radio"]:checked, variant-selects[data-section="${this.sectionId}"] input[type="radio"]:checked`
        );
        const scent = selected && (selected.value || "").trim();
        this.setLabel(this.productTitle, scent);

        const sourceButton =
          (html && html.getElementById && html.getElementById(`ProductSubmitButton-${this.sectionId}`)) ||
          this.inFlowButton;
        if (sourceButton && this.submitButton && this.labelEl) {
          const disabled = sourceButton.hasAttribute("disabled");
          this.submitButton.toggleAttribute("disabled", disabled);
          const span = sourceButton.querySelector("span");
          if (span) this.labelEl.textContent = span.textContent.trim();
        }
      }

      // Titel op de bovenste regel (mag afkappen), geur achter de prijs.
      setLabel(title, scent) {
        const hasScent = scent && scent !== "Default Title";
        if (this.variantEl && (title || hasScent)) this.variantEl.textContent = title || scent;
        if (this.scentEl) this.scentEl.textContent = hasScent && title ? `· ${scent}` : "";
      }

      bindCookieBanner() {
        if (this.cookieBanner && this.cookieObserver) return;
        this.cookieBanner = document.getElementById("shopify-pc__banner");
        if (!this.cookieBanner || this.cookieObserver || !("ResizeObserver" in window)) return;
        this.cookieObserver = new ResizeObserver(() => {
          this.offsetCookie();
          this.syncVisibility();
        });
        this.cookieObserver.observe(this.cookieBanner);
      }

      cookieVisible() {
        const banner = this.cookieBanner;
        if (!banner) return false;
        const style = window.getComputedStyle(banner);
        if (style.display === "none" || style.visibility === "hidden") return false;
        if (banner.getAttribute("aria-hidden") === "true") return false;
        return banner.getBoundingClientRect().height > 8;
      }

      offsetCookie() {
        const height = this.cookieVisible() ? Math.ceil(this.cookieBanner.getBoundingClientRect().height) : 0;
        const offset = `${height}px`;
        this.style.setProperty("--ajen-sticky-offset", offset);
        this.style.bottom = offset;
      }

      syncVisibility() {
        const cookieUp = this.cookieVisible();
        const show = this.mediaQuery.matches && !this.footerVisible && (cookieUp || !this.inFlowVisible);
        this.toggleAttribute("hidden", !show);
        document.documentElement.classList.toggle("ajen-sticky-atc-visible", show);
        this.offsetCookie();
      }
    }
  );
}
